/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
import React, { useState } from 'react'
import { UniversalPortal } from '@jesstelford/react-portal-universal'
import styled from 'styled-components'
import { MdClose } from 'react-icons/md'
import { IoMdStar } from 'react-icons/io'
import Wrapper from 'common/wrapper'
import ReviewForm from 'components/course/review/review-form'
import AnimatedModal from 'common/animations/animated-modal'

const ModalStyled = styled.div`
  background: var(--sky);
  position: absolute;
  top: 15%;
  bottom: 15%;
  left: 0;
  right: 0;
  margin: auto;
  min-height: 550px;
  box-sizing: border-box;
  max-width: calc(100% - 32px);
  border-radius: 4px;
  height: fit-content;
  padding: 16px;
  h3 {
    padding-bottom: 1em;
  }
  .title, h3 {
    font-size: 16px;
    line-height: 20px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 23px;
    margin-bottom: 15px;
    border-bottom: 1px solid rgba(174, 183, 193, .16);
  }
  .modal {
    &-close {
      cursor: pointer;
    }
    &-close:hover {
      transform: scale(1.2);
    }
    border-bottom: 1px solid rgba(174, 183, 193, .16);
  }
  .star-container {
    margin-top: 35px;
    margin-bottom: 67px;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
    display: grid;
    grid-template-columns: repeat(5, 30px);
    grid-column-gap: 10px;
  }
  .start {
    position: relative;
    background: transparent;
    border: none;
    outline: 0;
    padding: 0;
    transition: .3s color;
    cursor: pointer;
    &:first-child::after {
      content: 'Muy Mala';
    }
    &:last-child::after {
      content: 'Lo recomiendo';
    }
    &:first-child::after, &:last-child::after {
      position: absolute;
      bottom: -15px;
      left: -15px;
      right: -15px;
      margin: auto;
      font-size: 12px;
      color: var(--baseSecondary)
    }
    :active {
      transform: scale(0.8);
      opacity: .8;
    }
    svg {
      transition: .5s;
    }
  }
  .active {
    svg {
      color: #F9C126 !important;
    }
  }
  @media screen and (min-width:320px) and (max-width:840px) and (orientation:landscape) {
    height: 90vh!important;
    min-height: 90vh!important;
    max-width: 90vw!important;
    overflow: scroll;
    top: 0;
    bottom: 0;
  }
  @media screen and (min-width: 350px) {
    .start svg {
      width: 35px;
      height: 35px;
    }
    .star-container {
      grid-template-columns: repeat(5, 35px);
      grid-column-gap: 15px;
    }
  }
  @media screen and (min-width: 768px) {
    padding: 32px;
    max-width: 891px;
    min-height: 600px;
    .header {
      padding-bottom: 30px;
      margin-bottom: 33px;
    }
    .title {
      font-size: 2em;
    }
    h3 {
      padding-bottom: 1em;
      font-size: 21px;
    }
    .star-container {
      grid-template-columns: repeat(5, 56px);
      grid-column-gap: 20px;
    }
    .start svg {
      width: 56px;
      height: 56px;
    }
    &:first-child::after, &:last-child::after {
      left: -5px;
      right: -5px;
      font-size: 14px;
    }
  }
`

function ReviewModal({ handleClick, isActiveModal }) {
  const [stars, setStars] = useState(0)
  const [state, setState] = useState(
    [
      { active: false },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
    ],
  )
  function handleStar(start) {
    setStars(start)
    const array = []
    for (let i = 0; i < start; i++) {
      array.push({ active: true })
    }
    const length = array.length + 1
    if (length <= 5) {
      for (let i = 0; i <= 5 - length; i++) {
        array.push({ active: false })
      }
    }
    setState(array)
  }

  function handleMouseMove(index) {
    const start = document.getElementsByClassName('start')
    for (let i = 0; i <= index; i++) {
      start[i].classList.add('active')
    }
  }

  function handleMouseOut(index) {
    const start = document.getElementsByClassName('start')
    for (let i = 0; i <= index; i++) {
      start[i].classList.remove('active')
    }
  }
  return (
    <UniversalPortal selector="#page-portal">
      <AnimatedModal show={isActiveModal}>
        <Wrapper>
          <ModalStyled>
            <div className="header">
                <h1 className="title">Valoración del curso</h1>
                <div className="modal-close" onClick={handleClick}>
                  <MdClose className="close" size={25} color="var(--baseSecondary)" />
                </div>
              </div>
            <div className="modal-review">
                <h3>¿Comó valorías la calidad de esté curso?</h3>
                <div className="star-container">
                  {state.map((start, index) => (
                    <button
                      key={`rs-${index}`}
                      className="start"
                      type="button"
                      onMouseOut={() => handleMouseOut(index)}
                      onMouseMove={() => handleMouseMove(index)}
                      onClick={() => handleStar(index + 1)}
                    >
                      <IoMdStar color={start.active ? '#F9C126' : '#AEB7C1'} size={30} />
                    </button>
                  ))}
                </div>
              </div>
            <h3>Deja un mensaje para todos los estudiantes</h3>
            <ReviewForm stars={stars} closeModal={handleClick} />
          </ModalStyled>
        </Wrapper>
      </AnimatedModal>
    </UniversalPortal>
  )
}

export default ReviewModal
